import { useRecoilValue } from "recoil";
import { IBaseResponse } from "../../commons/types/base";
import { IComandasPorFase, IComandasPorPlano, IComandasPorStatus, IEtapasJaRealizadas } from "../../commons/types/dashboard";
import { useAxiosWrapper } from "../../services/axiosWrapper";
import { authAtom } from "../usuarios/AuthState";
import { useUsuarioActions } from "../usuarios/usuario.actions";

function useGraficosActions() {
  const userActions = useUsuarioActions();
  const axiosWrapper = useAxiosWrapper();
  const authState = useRecoilValue(authAtom);
  const baseUrl = `${process.env.REACT_APP_API_URL}/v1/empresas/${authState?.empresaId}/dashboard`;
  if (!authState || authState!.empresaId === undefined) {
    userActions.logout();
  }

  return {
    getComandasPorStatus,
    getComandasPorFase,
    getEtapasJaRealizadas,
    getComandasPorPlano,
    getComandasHistoricoAcao,
    getMediaRecolocacao,
    getVolumeIndicacoesVagas
  }

  async function getComandasPorStatus(): Promise<IComandasPorStatus[]> {
    const resp: IComandasPorStatus[] = await axiosWrapper.get(
      `${baseUrl}/comandasPorStatus`
    );
    return resp;
  }

  async function getComandasPorFase(): Promise<IComandasPorFase[]> {
    const resp: IComandasPorFase[] = await axiosWrapper.get(`${baseUrl}/comandasPorFase`);
    return resp;
  }

  async function getComandasPorPlano(): Promise<IComandasPorPlano[]> {
    const resp: IComandasPorPlano[] = await axiosWrapper.get(`${baseUrl}/comandasPorPlano`);
    return resp;
  }

  async function getComandasHistoricoAcao(): Promise<IComandasPorPlano[]> {
    const resp: IComandasPorPlano[] = await axiosWrapper.get(`${baseUrl}/comandasHistoricoAcao`);
    return resp;
  }

  async function getEtapasJaRealizadas(): Promise<IEtapasJaRealizadas[]> {
    const resp: IEtapasJaRealizadas[] = await axiosWrapper.get(`${baseUrl}/etapasJaRealizadas`);
    return resp;
  }

  async function getMediaRecolocacao(): Promise<number> {
    const resp: number = await axiosWrapper.get(`${baseUrl}/mediaRecolocacao`);
    return resp;
  }

  async function getVolumeIndicacoesVagas(): Promise<number> {
    const resp: number = await axiosWrapper.get(`${baseUrl}/indicacoesVagas`);
    return resp;
  }
}

export { useGraficosActions };
